import { createContext } from 'react';

import { Operation, OperationType } from '../model/operation';
import { AliceApp } from '../model/skill';

interface CurrentAliceAppContextParams {
    aliceApp: AliceApp;
    refreshAliceApp: () => void;
    operations: Operation[];
    addOperation: (o: Operation) => void;
    lastOperationType?: OperationType;
    lastOperationComment?: string;
    fetchOperations: () => void;
}

const CurrentAliceAppContext = createContext<CurrentAliceAppContextParams | null>(null);

export { CurrentAliceAppContext };
